import React from 'react';
import Beach from 'mdi-material-ui/Beach';
import Fish from 'mdi-material-ui/Fish';
import Hammer from 'mdi-material-ui/Hammer';
import Parachute from 'mdi-material-ui/Parachute';
import SafetyGoggles from 'mdi-material-ui/SafetyGoggles';
import WalletTravel from 'mdi-material-ui/WalletTravel';
import TrophyVariant from 'mdi-material-ui/TrophyVariant';
import { ReactComponent as Briefcase } from 'app/assets/icons/briefcase-variant.svg';
import { TravelGoalDescriptionEnum } from 'app/shared/enums/TravelGoalDescription.enum';

import { TravelPurposeIconProps } from './TravelPurposeIcon.interface';
import { useStyles } from './TravelPurposeIcon.styles';

export default function TravelPurposeIcon({
  dictionaryEntryKey,
}: TravelPurposeIconProps) {
  const classes = useStyles();

  switch (dictionaryEntryKey) {
    case TravelGoalDescriptionEnum.Sightseeing:
      return <Beach className={classes.icon} />;
    case TravelGoalDescriptionEnum.Skiing:
      return <SafetyGoggles className={classes.icon} />;
    case TravelGoalDescriptionEnum.Diving:
      return <Fish className={classes.icon} />;
    case TravelGoalDescriptionEnum.CompetitiveSports:
      return <TrophyVariant className={classes.icon} />;
    case TravelGoalDescriptionEnum.ExtremeSports:
      return <Parachute className={classes.icon} />;
    case TravelGoalDescriptionEnum.PhysicalWork:
      return <Hammer className={classes.icon} />;
    case TravelGoalDescriptionEnum.BusinessTrip:
      return <Briefcase className={classes.icon} aria-hidden={true} />;
    default:
      return <WalletTravel className={classes.icon} />;
  }
}
